<template>
  <!--
  <div>
  <a href="tel:+79512237737" onclick="yaCounter50723809.reachGoal('call_ok'); return true;">
    <v-btn
      class="hidden-md-and-up"
      fixed
      dark
      fab
      bottom
      right
      color="pink"
    >
      <v-icon>call</v-icon>
    </v-btn>
  </a>
  </div>
-->
<v-speed-dial
  v-model="fab"
  fixed
  dark
  fab
  bottom
  right
  color="pink"
>
  <v-btn
    slot="activator"
    v-model="fab"
    color="blue darken-2"
    dark
    fab
  >
    <v-icon>more_vert</v-icon>
    <v-icon>close</v-icon>
  </v-btn>

  <!--PHONE-->
  <a href="tel:+79512237737"
    onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
  >
    <v-btn
      fab
      dark
      color="pink"
    >
      <v-icon>call</v-icon>
    </v-btn>
  </a>

  <!--WHATSAPP-->
  <a href="https://wa.me/79512237737"
    target="_blank"
    onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
  >
    <v-btn
      fab
      dark
      color="green"
    >
      <font-awesome-icon size="2x" :icon="['fab', 'whatsapp']"></font-awesome-icon>
    </v-btn>
  </a>

  <!--VIBER-->
  <a href="viber://chat?number=79512237737"
    target="_blank"
    onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
  >
    <v-btn
      fab
      dark
      color="#59267c"
    >
      <font-awesome-icon size="2x" :icon="['fab', 'viber']"></font-awesome-icon>
    </v-btn>
  </a>

</v-speed-dial>
</template>

<script>
export default {
  data: () => ({
    direction: 'top',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: 'slide-y-reverse-transition'
  })
}
</script>

<style scoped>
a,
a:hover,
a:visited,
a:active {
  color: black;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/malina/ButtonCall.vue